module.exports = __webpack_public_path__ + "static/media/credit-card.0ed29c37.png";